module.exports = __webpack_public_path__ + "static/eyes-background-e971c89f29d7257b3111aa326842ffde.png";